import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';

function InboundMarketing() {
  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable certain keyboard shortcuts
    const handleKeyDown = (e) => {
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J')) ||
        (e.ctrlKey && e.key === 'U')
      ) {
        e.preventDefault();
        return false;
      }
    };

    // Disable text selection and copy
    const handleCopy = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable drag
    const handleDragStart = (e) => {
      e.preventDefault();
      return false;
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('dragstart', handleDragStart);

    // Disable text selection via CSS
    document.body.style.userSelect = 'none';
    document.body.style.webkitUserSelect = 'none';
    document.body.style.msUserSelect = 'none';

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('dragstart', handleDragStart);
      document.body.style.userSelect = '';
      document.body.style.webkitUserSelect = '';
      document.body.style.msUserSelect = '';
    };
  }, []);

  return (
    <div className="bg-black text-white min-h-screen overflow-x-hidden w-full">
      {/* Navbar */}
      <Navbar />

      {/* Protection styles for images */}
      <style jsx>{`
        img {
          pointer-events: none;
          user-select: none;
          -webkit-user-drag: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
        }
        * {
          box-sizing: border-box;
        }
        body, #root {
          overflow-x: hidden;
          max-width: 100vw;
        }
      `}</style>

      {/* Background stars effect */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        {[...Array(80)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-white rounded-full opacity-50"
            style={{
              width: Math.random() * 2 + 1 + 'px',
              height: Math.random() * 2 + 1 + 'px',
              top: Math.random() * 100 + '%',
              left: Math.random() * 100 + '%',
            }}
          />
        ))}
      </div>

      {/* Hero Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-16 sm:py-32 overflow-hidden min-h-screen flex items-center">
        {/* Background Image */}
        <div className="absolute inset-0 overflow-hidden">
          <img 
            src="/Assests/home_page_42.png" 
            alt="Relationship Marketing Background" 
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/60"></div>

        <div className="max-w-7xl mx-auto relative z-10 w-full">

          {/* Main Heading */}
          <h1 className="text-2xl sm:text-4xl lg:text-6xl font-bold text-white mb-8 leading-tight max-w-6xl">
            Relationship Marketing: Building Long-Term Loyalty Through Customer Engagement
          </h1>

          {/* Description */}
          <p className="text-gray-300 text-lg lg:text-xl leading-relaxed max-w-4xl mb-12">
            In today's competitive marketplace, success isn't just about making sales—it's about building meaningful connections that last. Relationship marketing transforms one-time buyers into lifelong advocates by prioritizing engagement, trust, and personalized experiences over transactional interactions.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4">
            <button className="px-8 py-3 bg-orange-500 text-white rounded-md font-medium hover:bg-orange-600 transition">
              Explore the Strategy
            </button>
            <button className="px-8 py-3 border border-white text-white rounded-md font-medium hover:bg-white hover:text-black transition">
              See the Results
            </button>
          </div>

        </div>
      </section>

      {/* Section 1: Chapter 1 - Why Relationship Marketing Matters Now More Than Ever */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20">
        <div className="max-w-7xl mx-auto">
          
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Side - Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden">
                <img 
                  src="/Assests/home_page_121.png" 
                  alt="Chapter 1 Marketing" 
                  className="w-full h-[450px] object-cover"
                />
              </div>
            </div>

            {/* Right Side - Content */}
            <div className="space-y-6">
              
              {/* Chapter Label */}
              <h3 className="text-3xl sm:text-5xl lg:text-6xl font-bold text-white">
                Chapter 1
              </h3>

              {/* Main Heading */}
              <h2 className="text-xl sm:text-3xl lg:text-4xl font-bold text-white leading-tight">
                Why Relationship Marketing Matters Now More Than Ever
              </h2>

              {/* Description */}
              <p className="text-gray-300 text-lg leading-relaxed">
                The business landscape has fundamentally shifted. Customers today demand more than quality products—they seek authentic connections with brands that understand their needs, values, and aspirations. In an era of endless choices, relationship marketing has evolved from a nice-to-have strategy into a critical competitive advantage that separates thriving businesses from those struggling to survive.
              </p>

            </div>

          </div>

        </div>
      </section>

      {/* Section 2: The Cost of Chasing New Customers */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-0">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-12 text-left">
            The Cost of Chasing New Customers
          </h2>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Side - Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden">
                <img 
                  src="/Assests/home_page_122.png" 
                  alt="Cost of Chasing New Customers" 
                  className="w-full h-[500px] object-cover"
                />
              </div>
            </div>

            {/* Right Side - Stats Cards */}
            <div className="space-y-6">
              
              {/* Card 1: 5x Higher Costs */}
              <div className="bg-black border-2 border-orange-500 rounded-xl p-6 hover:bg-orange-500/10 transition">
                <h3 className="text-2xl font-bold text-white mb-4">
                  5x Higher Costs
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Acquiring a new customer costs up to five times more than retaining an existing one, according to Harvard Business Review research.
                </p>
              </div>

              {/* Card 2: 33% More Revenue */}
              <div className="bg-black border-2 border-orange-500 rounded-xl p-6 hover:bg-orange-500/10 transition">
                <h3 className="text-2xl font-bold text-white mb-4">
                  33% More Revenue
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Repeat customers spend 33% more than new customers, making retention highly profitable (Flowium).
                </p>
              </div>

              {/* Card 3: 95% Profit Boost */}
              <div className="bg-black border-2 border-orange-500 rounded-xl p-6 hover:bg-orange-500/10 transition">
                <h3 className="text-2xl font-bold text-white mb-4">
                  95% Profit Boost
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Retention increases profits by up to 95% with just a 5% improvement in customer retention rates (Bain & Company).
                </p>
              </div>

            </div>

          </div>

          {/* Bottom Description */}
          <div className="mt-12">
            <p className="text-gray-300 text-lg leading-relaxed max-w-5xl mx-auto text-center">
              These compelling statistics reveal a fundamental truth: investing in existing customer relationships delivers exponential returns compared to the constant pursuit of new prospects. Smart businesses recognize that loyalty isn't just cost-effective—it's the foundation of sustainable growth.
            </p>
          </div>

        </div>
      </section>

      {/* Section 3: Retention - The Hidden Growth Engine */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20">
        <div className="max-w-6xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8 text-left">
            Retention: The Hidden Growth Engine
          </h2>

          {/* Description */}
          <p className="text-gray-300 text-lg lg:text-xl leading-relaxed">
            Traditional marketing funnels focus on filling the top with new prospects, but they fail to address the critical leak at the bottom. Relationship marketing plugs that leak by transforming customers into advocates who not only stay but actively recruit others. This compound effect creates a self-sustaining growth engine that becomes stronger over time, reducing dependency on expensive acquisition channels.
          </p>

        </div>
      </section>

      {/* Section 4: The Shift from Transactional to Relational Marketing */}
      {/* Section 4: The Shift from Transactional to Relational Marketing */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 bg-black">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-12">
            The Shift from Transactional to Relational Marketing
          </h2>

          {/* Arrow Cards Container */}
          <div className="flex flex-col lg:flex-row items-center justify-center mb-12">
            
            {/* Card 1: Transactional Focus - WITH RIGHT ARROW ONLY */}
            <div className="relative flex-1 max-w-md">
              <div className="relative bg-black border-2 border-orange-500 h-48 flex items-center justify-center">
                <div className="text-center px-6">
                  {/* Icon */}
                  <div className="flex justify-center mb-3">
                    <svg className="w-10 h-10 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-white">
                    Transactional Focus
                  </h3>
                </div>
                
                {/* Right Arrow */}
                <div className="hidden lg:block absolute -right-3 top-1/2 -translate-y-1/2 w-0 h-0 border-t-[24px] border-t-transparent border-l-[24px] border-l-orange-500 border-b-[24px] border-b-transparent z-10"></div>
                <div className="hidden lg:block absolute -right-2.5 top-1/2 -translate-y-1/2 w-0 h-0 border-t-[22px] border-t-transparent border-l-[22px] border-l-black border-b-[22px] border-b-transparent z-20"></div>
              </div>
            </div>

            {/* Card 2: Relationship Priority - WITH LEFT AND RIGHT ARROWS */}
            <div className="relative flex-1 max-w-md lg:-ml-3">
              <div className="relative bg-black border-t-2 border-b-2 border-r-2 border-orange-500 h-48 flex items-center justify-center">
                <div className="text-center px-6">
                  {/* Icon */}
                  <div className="flex justify-center mb-3">
                    <svg className="w-10 h-10 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-white">
                    Relationship Priority
                  </h3>
                </div>
                
                {/* Right Arrow */}
                <div className="hidden lg:block absolute -right-3 top-1/2 -translate-y-1/2 w-0 h-0 border-t-[24px] border-t-transparent border-l-[24px] border-l-orange-500 border-b-[24px] border-b-transparent z-10"></div>
                <div className="hidden lg:block absolute -right-2.5 top-1/2 -translate-y-1/2 w-0 h-0 border-t-[22px] border-t-transparent border-l-[22px] border-l-black border-b-[22px] border-b-transparent z-20"></div>
              </div>
            </div>

            {/* Card 3: Sustainable Growth - WITH LEFT ARROW ONLY */}
            <div className="relative flex-1 max-w-md lg:-ml-3">
              <div className="relative bg-black h-48 flex items-center justify-center border-t-2 border-b-2 border-r-2 border-orange-500 rounded-r-lg">
                <div className="text-center px-6">
                  {/* Icon */}
                  <div className="flex justify-center mb-3">
                    <svg className="w-10 h-10 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-white">
                    Sustainable Growth
                  </h3>
                </div>
              </div>
            </div>

          </div>

          {/* Content Below Cards */}
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            
            {/* Column 1: Transactional Focus Description */}
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-white">
                Transactional Focus
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Traditional marketing emphasizes quick sales, one-off transactions, and immediate revenue generation without considering long-term customer value.
              </p>
            </div>

            {/* Column 2: Relationship Priority Description */}
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-white">
                Relationship Priority
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Relationship marketing prioritizes ongoing engagement, emotional connection, and mutual value creation over short-term gains.
              </p>
            </div>

            {/* Column 3: Sustainable Growth Description */}
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-white">
                Sustainable Growth
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Long-term customer bonds create predictable revenue streams, lower marketing costs, and organic brand advocacy that fuels expansion.
              </p>
            </div>

          </div>

          {/* Historical Context Box */}
          <div className="bg-gradient-to-r from-orange-900/40 to-orange-800/30 border-l-4 border-orange-500 rounded-lg p-8">
            <div className="flex flex-wrap gap-4">
              {/* Icon */}
              <div className="flex-shrink-0">
                <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>

              {/* Content */}
              <div>
                <p className="text-gray-200 text-base leading-relaxed">
                  <span className="font-bold text-white">Historical Context:</span> Leonard Berry coined the term "relationship marketing" in the 1980s to emphasize the strategic importance of long-term customer bonds over transactional exchanges. His pioneering work transformed how businesses approach customer engagement.
                </p>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* Section 5: Chapter 2 - Core Principles of Relationship Marketing */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-8 bg-black">
        <div className="max-w-7xl mx-auto">
          
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Side - Content */}
            <div className="space-y-6">

              {/* Main Heading */}
              <h2 className="text-xl sm:text-3xl lg:text-4xl font-bold text-white leading-tight">
                Core Principles of Relationship Marketing
              </h2>

              {/* Description */}
              <p className="text-gray-300 text-lg leading-relaxed">
                Successful relationship marketing isn't built on tactics alone—it requires a fundamental shift in how organizations view and interact with customers. These core principles form the foundation of every meaningful customer relationship, guiding strategic decisions and daily interactions alike. Master these principles, and you'll create connections that withstand competitive pressure and economic uncertainty.
              </p>

            </div>

            {/* Right Side - Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden">
                <img 
                  src="/Assests/home_page_123.png" 
                  alt="Chapter 2 Core Principles" 
                  className="w-full h-[400px] object-cover"
                />
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* Section 6: Four Pillars of Relationship Marketing */}
      <section className="relative px-4 sm:px-8 lg:px-8 py-20 bg-black">
        {/* Background Image */}
        <div className="absolute inset-0 overflow-hidden opacity-30">
          <img 
            src="/Assests/home_page_15.png" 
            alt="Four Pillars Background" 
            className="w-full h-full object-cover"
          />
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-12">
            Four Pillars of Relationship Marketing
          </h2>

          {/* Four Pillars Grid - 2x2 */}
          <div className="grid md:grid-cols-2 gap-6">
            
            {/* Pillar 1: Trust */}
            <div className="bg-black/80 border-2 border-orange-500 rounded-2xl p-8 hover:bg-orange-500/10 transition">
              {/* Icon */}
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-white mb-4">
                Trust
              </h3>

              {/* Description */}
              <p className="text-gray-300 text-base leading-relaxed">
                Customers must believe in your brand's reliability, integrity, and commitment to delivering on promises consistently. Trust is earned through transparency, accountability, and ethical business practices that put customer interests first.
              </p>
            </div>

            {/* Pillar 2: Communication */}
            <div className="bg-black/80 border-2 border-orange-500 rounded-2xl p-8 hover:bg-orange-500/10 transition">
              {/* Icon */}
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                </svg>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-white mb-4">
                Communication
              </h3>

              {/* Description */}
              <p className="text-gray-300 text-base leading-relaxed">
                Two-way dialogue that actively listens and responds thoughtfully to customer needs, concerns, and feedback. Effective communication creates understanding and demonstrates that customer voices genuinely matter.
              </p>
            </div>

            {/* Pillar 3: Empathy */}
            <div className="bg-black/80 border-2 border-orange-500 rounded-2xl p-8 hover:bg-orange-500/10 transition">
              {/* Icon */}
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-white mb-4">
                Empathy
              </h3>

              {/* Description */}
              <p className="text-gray-300 text-base leading-relaxed">
                Understanding and anticipating customer feelings, preferences, and pain points through genuine care and attention. Empathy transforms service from transactional to transformational.
              </p>
            </div>

            {/* Pillar 4: Commitment */}
            <div className="bg-black/80 border-2 border-orange-500 rounded-2xl p-8 hover:bg-orange-500/10 transition">
              {/* Icon */}
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-white mb-4">
                Commitment
              </h3>

              {/* Description */}
              <p className="text-gray-300 text-base leading-relaxed">
                Mutual desire to maintain and grow the relationship over time through continued investment, adaptation, and shared value creation that benefits both parties.
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* Section 7: Customer-Centric Mindset - From Transactions to Connections */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-8 bg-orange-500/60">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-12">
            Customer-Centric Mindset: From Transactions to Connections
          </h2>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Side - Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden">
                <img 
                  src="/Assests/home_page_124.png" 
                  alt="Customer Centric Mindset" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Right Side - Content */}
            <div className="space-y-8">
              
              {/* Point 1 */}
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <span className="text-3xl font-bold text-black">01</span>
                  <div className="flex-1 h-0.5 bg-black"></div>
                </div>
                <h3 className="text-2xl font-bold text-black">
                  Prioritize Customer Benefits
                </h3>
                <p className="text-black text-base leading-relaxed">
                  Focus relentlessly on what benefits the customer, not just what serves company objectives. Every decision should pass through a customer-value filter.
                </p>
              </div>

              {/* Point 2 */}
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <span className="text-3xl font-bold text-black">02</span>
                  <div className="flex-1 h-0.5 bg-black"></div>
                </div>
                <h3 className="text-2xl font-bold text-black">
                  Leverage Data Intelligently
                </h3>
                <p className="text-black text-base leading-relaxed">
                  Use data and technology to personalize experiences and communications in ways that feel helpful, not invasive. Smart data usage enhances relevance.
                </p>
              </div>

              {/* Point 3 */}
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <span className="text-3xl font-bold text-black">03</span>
                  <div className="flex-1 h-0.5 bg-black"></div>
                </div>
                <h3 className="text-2xl font-bold text-black">
                  Individualize Interactions
                </h3>
                <p className="text-black text-base leading-relaxed">
                  Treat customers as unique individuals with distinct preferences, not as anonymous database entries or demographic segments. Personalization creates connection.
                </p>
              </div>

            </div>

          </div>

          {/* Bottom Quote */}
          <div className="mt-12 border-l-4 border-white pl-6">
            <p className="text-white text-lg italic leading-relaxed">
              "People don't want to be targeted. They want to be understood, valued, and treated as individuals who matter."
            </p>
          </div>

        </div>
      </section>

      {/* Section 8: Chapter 3 - The Business Benefits of Relationship Marketing */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-8 bg-black">
        <div className="max-w-7xl mx-auto">
          
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Side - Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden">
                <img 
                  src="/Assests/home_page_125.png" 
                  alt="Chapter 3 Business Benefits" 
                  className="w-full h-[380px] object-cover"
                />
              </div>
            </div>

            {/* Right Side - Content */}
            <div className="space-y-6">

              {/* Main Heading */}
              <h2 className="text-xl sm:text-3xl lg:text-4xl font-bold text-white leading-tight">
                The Business Benefits of Relationship Marketing
              </h2>

              {/* Description */}
              <p className="text-gray-300 text-lg leading-relaxed">
                Relationship marketing isn't just philosophically appealing—it delivers measurable business results that impact the bottom line. From revenue growth to operational efficiency, the benefits compound over time as relationships deepen. Organizations that embrace this approach consistently outperform competitors focused solely on acquisition, creating sustainable competitive advantages that are difficult to replicate.
              </p>

            </div>

          </div>

        </div>
      </section>  

      {/* Section 9: Loyalty Drives Revenue and Advocacy */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 bg-black">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-12">
            Loyalty Drives Revenue and Advocacy
          </h2>

          <div className="grid lg:grid-cols-2 gap-12 items-start">
            
            {/* Left Side - Stats */}
            <div className="space-y-8">
              
              {/* Stat 1: 51% */}
              <div className="space-y-4">
                <h3 className="text-4xl sm:text-6xl lg:text-7xl font-bold text-orange-500">
                  51%
                </h3>
                <h4 className="text-2xl font-bold text-white">
                  Higher Revenue
                </h4>
                <p className="text-gray-300 text-base leading-relaxed">
                  Fully engaged customers generate 51% more revenue than average customers, according to Harte Hanks research.
                </p>
              </div>

              {/* Stat 2: 52% */}
              <div className="space-y-4">
                <h3 className="text-4xl sm:text-6xl lg:text-7xl font-bold text-orange-500">
                  52%
                </h3>
                <h4 className="text-2xl font-bold text-white">
                  Program Preference
                </h4>
                <p className="text-gray-300 text-base leading-relaxed">
                  52% of consumers actively choose brands based on the strength and appeal of loyalty programs (Cardlytics).
                </p>
              </div>

              {/* Stat 3: 3x */}
              <div className="space-y-4">
                <h3 className="text-4xl sm:text-6xl lg:text-7xl font-bold text-orange-500">
                  3x
                </h3>
                <h4 className="text-2xl font-bold text-white">
                  Advocacy Multiplier
                </h4>
                <p className="text-gray-300 text-base leading-relaxed">
                  Loyal customers become brand advocates, generating word-of-mouth marketing worth three times paid advertising.
                </p>
              </div>

            </div>

            {/* Right Side - Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden">
                <img 
                  src="/Assests/home_page_126.png" 
                  alt="Loyalty and Advocacy" 
                  className="w-full h-[500px] sm:h-[650px] object-cover"
                />
              </div>
            </div>

          </div>

          {/* Bottom Description */}
          <div className="mt-12">
            <p className="text-gray-300 text-lg leading-relaxed">
              The advocacy effect creates a powerful multiplier: satisfied customers don't just return themselves—they bring others with them. This organic growth channel becomes increasingly valuable as acquisition costs rise across digital platforms. Brand advocacy represents the ultimate validation that your relationship marketing strategy is working.
            </p>
          </div>

        </div>
      </section>

      {/* Section 10: Stability Through Economic Ups and Downs */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 bg-black">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-12">
            Stability Through Economic Ups and Downs
          </h2>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Side - Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden">
                <img 
                  src="/Assests/home_page_127.png" 
                  alt="Economic Stability" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Right Side - Cards */}
            <div className="space-y-6">
              
              {/* Card 1: Recession Resilience */}
              <div className="bg-black border-2 border-orange-500 rounded-xl p-6 hover:bg-orange-500/10 transition">
                <h3 className="text-2xl font-bold text-white mb-4">
                  Recession Resilience
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Loyal customers maintain spending levels even during economic downturns, providing predictable revenue when new customer acquisition becomes more challenging and expensive.
                </p>
              </div>

              {/* Card 2: Market Volatility Buffer */}
              <div className="bg-black border-2 border-orange-500 rounded-xl p-6 hover:bg-orange-500/10 transition">
                <h3 className="text-2xl font-bold text-white mb-4">
                  Market Volatility Buffer
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Strong relationships create insulation against competitive pressure, pricing wars, and market disruptions. Customers choose familiar brands during uncertain times.
                </p>
              </div>

              {/* Card 3: Long-Term Predictability */}
              <div className="bg-black border-2 border-orange-500 rounded-xl p-6 hover:bg-orange-500/10 transition">
                <h3 className="text-2xl font-bold text-white mb-4">
                  Long-Term Predictability
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Relationship marketing builds financial resilience through recurring revenue streams and higher customer lifetime values that enable better forecasting and strategic planning.
                </p>
              </div>

            </div>

          </div>

        </div>
      </section>

      {/* Section 11: Chapter 4 - Real-World Success Stories */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 overflow-hidden">
        {/* Background Image with Dark Overlay */}
        <div className="absolute inset-0 overflow-hidden">
          <img 
            src="/Assests/home_page_128.png" 
            alt="Success Stories Background" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/40"></div>
        </div>

        <div className="max-w-5xl mx-auto relative z-10">
          
          {/* Content Card */}
          <div className="bg-black/60 backdrop-blur-sm border-2 border-gray-700 rounded-3xl p-6 sm:p-8 lg:p-12">
            
            {/* Chapter Label */}
            <h3 className="text-3xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
              Chapter 4
            </h3>

            {/* Main Heading */}
            <h2 className="text-xl sm:text-3xl lg:text-4xl font-bold text-white mb-8 leading-tight">
              Real-World Success Stories
            </h2>

            {/* Description */}
            <p className="text-gray-300 text-lg leading-relaxed">
              Theory becomes reality when we examine organizations that have mastered relationship marketing. These success stories span industries from hospitality to fast food to finance, proving that the principles apply universally. Each brand has developed unique approaches tailored to their customers' needs, yet all share common threads: genuine commitment to customer relationships, strategic use of technology, and unwavering focus on delivering value beyond the transaction.
            </p>

          </div>

        </div>
      </section>

    </div>
  );
}

export default InboundMarketing;